import { useEffect, useState } from "react";

import { api } from "@/APIRequests";

/**
 * Fetches tips, banner, draft notes count, and patient count for the provider dashboard.
 * @returns {{ banner: Object|null, patientCount: number|null, providerDraftNotes: number, tips: Array|null }}
 */
export function useDashboardData() {
  const [banner, setBanner] = useState(null);
  const [patientCount, setPatientCount] = useState(null);
  const [providerDraftNotes, setProviderDraftNotes] = useState(0);
  const [tips, setTips] = useState(null);

  useEffect(() => {
    const options = { params: { showLoader: false } };

    api.provider
      .fetch_aptihealth_tips({ options })
      .then((response) => {
        setTips(response.tips);
      })
      .catch((err) => {
        console.error("Failed to fetch aptihealth tips:", err);
      });

    api.provider
      .fetch_provider_banner({ options })
      .then((response) => {
        if (response && Object.keys(response).length > 0) {
          setBanner(response);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch provider banner:", err);
      });

    api.provider
      .fetch_provider_draft_notes_count()
      .then((response) => {
        setProviderDraftNotes(response);
      })
      .catch((err) => {
        console.error("Failed to fetch draft notes count:", err);
      });

    api.provider
      .fetch_patient_count()
      .then((response) => {
        setPatientCount(response.user);
      })
      .catch((err) => {
        console.error("Failed to fetch patient count:", err);
      });
  }, []);

  return { banner, patientCount, providerDraftNotes, tips };
}
